import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('surveys', 'submitReferralForm', [
  'MESSAGE',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'refferal_forms',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/surveys/submitReferralForm.js